onComplete(function () {

	const isHome = document.querySelector("html[data-home='true']");
	const header = document.querySelector('header.nav-header');

	let currentScrollPos = document.documentElement.scrollTop;

	const changeNavbarBg = () => {
		currentScrollPos = document.documentElement.scrollTop;
		if (currentScrollPos > 50) {
			header.style.backgroundColor = "var(--primary-bg)";
			header.style.boxShadow = "var(--box-shadow-2)";
		} else {
			header.style.backgroundColor = "transparent";
			header.style.boxShadow = "unset";
		}
	}

	window.addEventListener('scroll', function () {

		if (isHome) {
			currentScrollPos = document.documentElement.scrollTop;
			changeNavbarBg()
		}

	});

	// wizard width

	const updateWizardWidth = () => {
		const wizardIndicators = document.querySelector('.wizard-indicators');

		if (wizardIndicators) {
			document.documentElement.style.setProperty(
				'--wizard-width',
				`${wizardIndicators.offsetWidth}px`
			);

			document.documentElement.style.setProperty(
				'--wizard-count',
				wizardIndicators.children.length
			);
		}
	};

	updateWizardWidth();

	window.addEventListener('resize', updateWizardWidth);

	// animatie voor counters
	const COUNT_ANIMATION_DURATION = 2000
	const COUNTER_START_DATE = Date.UTC(2026, 7, 26) // 26 augustus 2026

	const getElapsedWeeks = () => {
		const millisecondsPerWeek = 7 * 24 * 60 * 60 * 1000
		return Math.max(
			0,
			Math.floor((Date.now() - COUNTER_START_DATE) / millisecondsPerWeek)
		)
	}

	const weeklyIncrements = [
		0,    // 1e item
		5,    // 2e item: Sloopklussen
		1000, // 3e item: kg beton gesloopt
		0     // 4e item
	]

	const observer = new IntersectionObserver((entries, observer) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				observer.unobserve(entry.target)

				const counterElement = entry.target.querySelector('.count-block-number')

				if (counterElement) {
					const rawText = counterElement.textContent.trim()
					const match = rawText.match(/^[\d.,]+/)
					const baseNumber = match
						? parseFloat(match[0].replace(/[.,]/g, ''))
						: 0

					const counterIndex = Array.from(
						document.querySelectorAll('.counters-section .count-block')
					).indexOf(entry.target)

					const targetNumber =
						baseNumber +
						(getElapsedWeeks() * (weeklyIncrements[counterIndex] || 0))

					const suffix = rawText.slice(match ? match[0].length : 0)
					const count = { value: 0 }

					anime({
						targets: count,
						value: targetNumber,
						easing: 'easeInOutSine',
						duration: COUNT_ANIMATION_DURATION,
						update: () => {
							counterElement.textContent =
								Math.round(count.value).toLocaleString('nl-NL') + suffix
						}
					})
				}
			}
		})
	}, {
		rootMargin: '0px 0px -32px 0px',
	})


	Array.from(
		document.querySelectorAll('.counters-section .count-block')
	).forEach(element => {
		observer.observe(element)
	})

	// accordion met afbeelding
	const setup = () => {
		const wrapper = document.querySelector('[id="img-accordion-wrapper"]');
		if (!wrapper) {
			return;
		}
		let openFirst = wrapper.getAttribute('data-open-first');
		openFirst = openFirst && openFirst !== 'false';

		const accordionImages = Array.from(
			wrapper.querySelectorAll('[data-partial="image"]')
		);
		const accordionItems = Array.from(
			wrapper.querySelectorAll('.collapse')
		);
		const setupItem = (index, item, image) => {
			const $item = $(item);
			if (index !== 0) {
				image.setAttribute('hidden', true);
			} else if (openFirst) {
				$item.collapse('show');
			}
			$item.on('shown.bs.collapse', function () {
				image.removeAttribute('hidden');
				for (let i = 0; i < accordionImages.length; i++) {
					if (accordionImages[i] !== image) {
						accordionImages[i].setAttribute('hidden', true);
					}
				}
			});
		}
		for (let i = 0; i < accordionItems.length; i++) {
			setupItem(i, accordionItems[i], accordionImages[i]);
		}
	}

	setup();
	if (window.editor) {
		window.editor.addEventListener('reloaded', setup);
	}

	const overlapSection = document.querySelector('.overlap-section');
	const kraan = document.querySelector('.section-img-animation');
	const kraanObserver = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				kraan.classList.add('in-view');
				kraanObserver.unobserve(entry.target);
			}
		});
	}, { threshold: 0.2 });

	if (kraan && overlapSection) {
		kraanObserver.observe(overlapSection);
	}

	// slide-in animatie voor img-animate-container afbeeldingen (komen van rechts binnen met een kleine bounce)
	// let op: de afbeelding zelf staat via right: -800px buiten het scherm, dus die kan nooit
	// de trigger voor de IntersectionObserver zijn (die komt immers nooit in beeld). Net als bij de
	// kraan-animatie hierboven observeren we daarom de omliggende sectie, die wel gewoon in beeld scrolt.
	const imageSlideInObserver = new IntersectionObserver((entries, observer) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				observer.unobserve(entry.target)

				Array.from(
					entry.target.querySelectorAll('.img-animate-container')
				).forEach(image => {
					anime({
						targets: image,
						right: '8px',
						duration: 700,
						easing: 'easeOutQuad',
						complete: () => {
							anime({
								targets: image,
								right: '0px',
								duration: 200,
								easing: 'easeOutQuad'
							})
						}
					})
				})
			}
		})
	}, { threshold: 0.2 })

	const imageSlideInSections = new Set(
		Array.from(document.querySelectorAll('.img-animate-container'))
			.map(image => image.closest('.overlap-section'))
			.filter(Boolean)
	)

	imageSlideInSections.forEach(section => {
		imageSlideInObserver.observe(section)
	})

});